import { render, staticRenderFns } from "./SchoolSelectStep.vue?vue&type=template&id=108cb58e&scoped=true&"
import script from "./SchoolSelectStep.vue?vue&type=script&lang=js&"
export * from "./SchoolSelectStep.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "108cb58e",
  null
  
)

export default component.exports